module.exports = __webpack_public_path__ + "img/edit.91d3ffb4.svg";